// extracted by mini-css-extract-plugin
module.exports = {"modal-header":"_2l8aX2hgkG-53b9cAavdl1","modal-dialog":"_2VP7UxTGtlZJTzfSSSbNR3"};